import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class DeviceService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	/**
	 * Get all devices
	 * @param {function} callback
	 */
	getAll(callback) {
		const url = "/ecosystem/api/devices";
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Get device by Id
	 * @param {string} deviceId
	 * @param {function} callback
	 */
	getById(deviceId, callback) {
		const url = `/ecosystem/api/devices/${deviceId}`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Get device by sourceId
	 * @param {string} sourceId
	 * @param {function} callback
	 */
	getBySourceId(sourceId, callback) {
		const url = `/ecosystem/api/devices/externalSourceId/${sourceId}`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Create an device
	 * @param {object} device
	 * @param {function} callback
	 */
	create(device, callback) {
		const url = "/ecosystem/api/devices";
		const body = JSON.stringify({
			device
		});
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Update an device
	 * @param {string} deviceId
	 * @param {object} device
	 * @param {function} callback
	 */
	update(deviceId, device, updateEntityData = false, callback) {
		const url = `/ecosystem/api/devices/${deviceId}`;
		const body = JSON.stringify({ device, updateEntityData });
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * Update a device by sourceId
	 * @param {string} sourceId
	 * @param {object} device
	 * @param {function} callback
	 */
	updateBySourceId(sourceId, device, callback) {
		const url = `/ecosystem/api/devices/externalSourceId/${sourceId}`;
		const body = JSON.stringify(device);
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * Check if a floorplan includes an device.
	 * @param {string} displayTargetId
	 * @param {function} callback
	 */

	getByDisplayTargetId(displayTargetId, callback) {
		const url = `/ecosystem/api/devices/getByDisplayTargetId/${displayTargetId}`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Remove an device from its display target
	 * @param {string} deviceId
	 * * @param {string} displayTargetId
	 * @param {function} callback
	 */
	removeDeviceFromDisplayTarget(deviceId, displayTargetId, callback) {
		const url = `/ecosystem/api/devices/${deviceId}/displayTarget/${displayTargetId}`;
		this._restClient.exec_put(url, callback);
	}

	/**
	 * delete a device
	 * @param {String} deviceId
	 */
	deleteDeviceType(deviceId, callback) {
		const url = `/ecosystem/api/devices/${deviceId}`;
		this._restClient.exec_delete(url, callback);
	}

	/**
	 * assign device type to devices
	 * @param {string} deviceTypeId
	 * * @param {string} devices
	 * @param {function} callback
	 */
	assignDeviceTypeToDevices(deviceTypeId, data, callback) {
		const url = `/ecosystem/api/devices/deviceType/${deviceTypeId}`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * Trigger discovery for devices and cameras.
	 * @param {object} data
	 * @param {function} callback
	 */
	triggerDiscovery(data, callback) {
		const url = `/ecosystem/api/devices/discovery`;
		const body = JSON.stringify(data);
		this._restClient.exec_post(url, body, callback);
	}

	
	triggerDiscoverySyncByFeedId(feedId, callback) {
		
		const url = `/ecosystem/api/devices/discovery/sync/${feedId}`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * retrieve last discovery by feed
	 * @param {function} callback
	 */

	retrieveLastDiscovery(callback) {
		
		const url = "/ecosystem/api/devices/lastDiscovery/feeds";
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Get discovery changes by id
	 * @param {*} discoveryId 
	 * @param {*} callback 
	 */
	getDiscoveryChanges(discoveryId, callback) {
		const url = `/ecosystem/api/devices/discovery/${discoveryId}`;
		this._restClient.exec_get(url, callback);
	}
}
